import { ISelectItem } from '../components/UI/Select/Select'
import { clientInstance } from '../utils/http-client'
import { baseAPICall } from './baseAPICall'

export interface CalendarOption {
  id: number
  nylas_calendar_id: string
  name: string
  description: string
  is_primary: boolean
  timezone: string
  read_only: boolean
  is_owned_by_user: boolean
  is_selected: boolean
}

export function toCalendarSelectItems(
  calendars: CalendarOption[]
): ISelectItem<number>[] {
  return calendars.map((cal) => ({
    label: `${cal.name}${cal.is_primary ? ' (Primary)' : ''}`,
    value: cal.id,
  }))
}

export async function getCalendars(integrationId: number) {
  return baseAPICall<CalendarOption[]>(() =>
    clientInstance.get(`/calendar-integration/${integrationId}/calendars/`)
  )
}

export async function selectCalendar(
  integrationId: number,
  calendarId: number
) {
  return baseAPICall<CalendarOption>(() =>
    clientInstance.post(
      `/calendar-integration/${integrationId}/calendars/${calendarId}/select/`
    )
  )
}
